import CustomSelect from './CustomSelect';

interface BooleanInputProps {
  label: string;
  placeholder: string;
  value: boolean;
  error?: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  isMandatory?: boolean;
}

function BooleanInput({
  label,
  placeholder,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
}: BooleanInputProps) {
  const displayValue =
    value === null || value === undefined ? '' : value ? 'Yes' : 'No';

  const handleChange = (newValue: string | string[]) => {
    if (typeof newValue === 'string') {
      onChange(newValue === 'Yes');
    }
  };

  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <CustomSelect
        value={displayValue}
        options={['Yes', 'No']}
        placeholder={placeholder || 'Select...'}
        disabled={disabled}
        isInvalid={!!error}
        onChange={handleChange}
        multiSelect={false}
        searchable={false}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default BooleanInput;
